module.exports = __webpack_public_path__ + "img/rightArrow2.493ef0ed.svg";